var path = 'areas/projects/views/azure_server_targetroles_info.html';
var html = "<div ng-show=\"step.Properties['Octopus.Action.TargetRoles']\"> <div class=\"alert alert-info form-group-narrow\"> Ensure you have at least one active deployment target matching the selected role(s) at the time of your deployment. <a class=alert-link href=http://g.octopushq.com/CloudRegionTargets target=_blank>Cloud Region targets</a> can be used when deploying cloud applications to multiple geographic regions. </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/azure_server_targetroles_info.html
// module id = 3440381504999721
// module chunks = 1